var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigliveEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.663 226.204C138.825 238.042 79.8452 231.283 52.4239 210.151C33.0649 195.232 32.0667 181.905 39.1238 158.035C45.1479 137.658 8 142.479 8 106.771C8 65.4887 76.5853 83.5614 102.035 78.8342C140.946 71.609 173.24 44.7625 214.823 48.3236C251.022 51.4275 266.466 75.2216 271.503 102.71C277.07 162.042 235.315 206.175 174.663 226.204Z",
    fill: "#CCE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8734 77.78L179.293 59.19C179.523 59.15 179.753 59.13 179.983 59.13C181.913 59.13 183.553 60.51 183.893 62.41L190.043 97.26C190.223 98.31 189.973 99.41 189.343 100.27L180.383 112.68C179.703 113.63 179.373 114.8 179.453 115.96L83.5734 132.87L73.8634 77.78H73.8734Z",
    fill: "#7A9CCB",
    stroke: "#215AA8",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.073 208.15C104.493 208.15 100.583 204.87 99.7834 200.34L79.4534 85.04C78.5534 79.91 81.9834 75 87.1134 74.1L139.463 64.87L187.023 99.25L201.683 182.38C202.583 187.51 199.153 192.42 194.023 193.32L110.723 208C110.173 208.1 109.623 208.15 109.073 208.15Z",
    fill: "#7A9CCB",
    stroke: "#215AA8",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.163 103.1C150.943 103.1 147.343 100.08 146.603 95.91L141.373 66.24L185.223 97.94L156.683 102.97C156.183 103.06 155.673 103.1 155.163 103.1Z",
    fill: "#D3DEEE",
    stroke: "#215AA8",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1234 216C90.1234 216 88.4234 214.57 88.0834 212.6L64.6134 79.53C64.4234 78.45 64.6634 77.36 65.2934 76.46C65.9234 75.56 66.8634 74.96 67.9534 74.77L168.353 57.06C168.593 57.02 168.833 57 169.073 57C171.073 57 172.773 58.43 173.123 60.4L196.583 193.47C196.973 195.7 195.483 197.84 193.243 198.24L92.8434 215.94C92.6034 215.98 92.3634 216 92.1234 216Z",
    fill: "#A6BDDC",
    stroke: "#215AA8",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.427 157.134L135.372 164.726C134.115 164.947 133.276 166.145 133.498 167.402L137.922 192.495C138.144 193.751 139.342 194.59 140.598 194.369L183.654 186.777C184.911 186.555 185.75 185.357 185.528 184.101L181.103 159.008C180.882 157.751 179.684 156.912 178.427 157.134Z",
    fill: "#4D7BB9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7634 223.91C81.1834 223.91 77.2734 220.63 76.4734 216.1L56.1434 100.8C55.2434 95.67 58.6734 90.76 63.8034 89.86L116.153 80.63L163.713 115.01L178.373 198.14C178.813 200.62 178.253 203.13 176.813 205.2C175.363 207.27 173.203 208.64 170.723 209.08L87.4234 223.76C86.8734 223.86 86.3234 223.9 85.7734 223.9L85.7634 223.91Z",
    fill: "white",
    stroke: "#215AA8",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.863 118.86C127.643 118.86 124.043 115.84 123.303 111.67L118.073 82L161.923 113.7L133.383 118.73C132.883 118.82 132.373 118.86 131.863 118.86Z",
    fill: "#D3DEEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.863 118.86C127.643 118.86 124.043 115.84 123.303 111.67L118.073 82L161.923 113.7L133.383 118.73C132.883 118.82 132.373 118.86 131.863 118.86Z",
    stroke: "#215AA8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M209.71 130.5C228.648 130.5 244 115.148 244 96.21C244 77.2722 228.648 61.92 209.71 61.92C190.772 61.92 175.42 77.2722 175.42 96.21C175.42 115.148 190.772 130.5 209.71 130.5Z",
    fill: "#0045A3"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M206.29 127.08C225.228 127.08 240.58 111.728 240.58 92.79C240.58 73.8522 225.228 58.5 206.29 58.5C187.352 58.5 172 73.8522 172 92.79C172 111.728 187.352 127.08 206.29 127.08Z",
    fill: "#3378D6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M222.67 101.42H205.53C203.18 101.42 201.28 99.52 201.28 97.17V75.71C201.28 73.36 203.18 71.46 205.53 71.46C207.88 71.46 209.78 73.36 209.78 75.71V92.92H222.67C225.02 92.92 226.92 94.82 226.92 97.17C226.92 99.52 225.02 101.42 222.67 101.42Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigliveEmptyState);
export default __webpack_public_path__ + "static/media/siglive-empty-state.ea82c3c48392ea92064a965714575f4e.svg";
export { ForwardRef as ReactComponent };